import Swal from 'sweetalert2';

// Success alert
export const showSuccess = (title, message = '', timer = 2000) => {
    return Swal.fire({
        icon: 'success',
        title: title,
        text: message,
        timer: timer,
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timerProgressBar: true
    });
};

// Error alert
export const showError = (title, message = '', timer = 5000) => {
    return Swal.fire({
        icon: 'error',
        title: title,
        text: message,
        timer: timer,
        showConfirmButton: true,
        toast: true,
        position: 'top-end',
        timerProgressBar: true
    });
};

// Warning alert
export const showWarning = (title, message = '', timer = 4000) => {
    return Swal.fire({
        icon: 'warning',
        title: title,
        text: message,
        timer: timer,
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timerProgressBar: true
    });
};

// Info alert
export const showInfo = (title, message = '', timer = 4000) => {
    return Swal.fire({
        icon: 'info',
        title: title,
        text: message,
        timer: timer,
        showConfirmButton: false,
        toast: true,
        position: 'top-end',
        timerProgressBar: true
    });
};

// Confirm dialog
export const showConfirm = (title, message = '', confirmText = 'Yes', cancelText = 'No') => {
    return Swal.fire({
        title: title,
        text: message,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: confirmText,
        cancelButtonText: cancelText
    });
};

// Loading alert
export const showLoading = (title = 'Loading...') => {
    return Swal.fire({
        title: title,
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
            Swal.showLoading();
        }
    });
};

// Close any open alert
export const closeAlert = () => {
    Swal.close();
};

export default Swal;

